import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function AdminTripsLayout({ children }: { children: React.ReactNode }) {
  const { t: tNav } = useTranslation("nav");

  return (
    <>
      <PageTitle>{tNav("trips")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/admin/trips")({
  component: function LayoutRoute() {
    return (
      <AdminTripsLayout>
        <Outlet />
      </AdminTripsLayout>
    );
  },
});
